var supportsVoiceOver = function supportsVoiceOver() {
  return (/Mac OS X/.test(navigator.userAgent)
  );
};

export default supportsVoiceOver;